import {throwOnResponseError} from '../../utils/createResponseError';

export const getTrueLayerPaymentStatusClient = async ({paymentSessionId, language}) => {
    const url = new URL(
        `/${language}/payments-integrations-webapp/props/getTrueLayerPaymentStatus`,
        window.location.origin
    );
    url.searchParams.set('paymentSessionId', paymentSessionId);

    const statusData = await fetch(url.href, {
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    });
    return statusData.json();
};

export async function initPaymentSession({
    paymentSessionId, provider, csrfToken, languageCode
}) {
    const url = new URL(
        `/${languageCode}/payment-providers/tl/sessions/${paymentSessionId}/init`,
        window.location.origin
    );

    const initResponse = await fetch(
        url.href,
        {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'csrf-token': csrfToken
            },
            body: JSON.stringify({
                providerId: provider.providerId,
                schemeId: provider.schemeId
            })
        }
    );

    throwOnResponseError(initResponse);
    return initResponse.json();
}
